import {Component, Input, Output, OnInit, EventEmitter} from '@angular/core';
import {AchatsService} from '@app/core';

@Component({
  selector: 'app-payment-types-list',
  templateUrl: './payment-types-list.component.html',
  styleUrls: ['./payment-types-list.component.scss']
})
export class PaymentTypesListComponent implements OnInit {

  constructor(private achatsService: AchatsService) { }
  @Input() modePayment: any;
  private list: Array<any>;
  @Input() resa2 : Boolean = false;
  @Output() setmodePayment = new EventEmitter<any>();


  ngOnInit() {
    this.list = this.achatsService.paymentTypesList;
  }

  public select(item) {
    this.setmodePayment.emit(item)
  }

  get paymentList(){
    return this.list;
  }

}
